
import { Component, Emit, Prop, Vue } from "vue-property-decorator"
import { TenantSupport } from "@/types/tenant"
import vSelect from "vue-select"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class SureViewSupportModal extends Vue {
	@Prop({ type: Boolean, required: true })
	value!: boolean

	@Prop({ type: [Object, String], default: null })
	supportAccess!: TenantSupport | null

	supportAccessTime: String | null = null

	private readonly supportTimes = [
		{
			label: "1 hour",
			value: "01:00:00"
		},
		{
			label: "4 hours",
			value: "4:00:00"
		},
		{
			label: "12 hours",
			value: "12:00:00"
		},
		{
			label: "1 day",
			value: "1.00:00:00"
		},
		{
			label: "1 week",
			value: "7.00:00:00"
		}
	]

	private get supportAccessOpen () {
		return this.value
	}

	private set supportAccessOpen (value: boolean) {
		this.$emit("input", value)
	}

	@Emit("allow-access")
	private allowAccess () {
		return this.supportAccessTime
	}

	@Emit("end-access")
	private endAccess () {

	}
}
